class MedianRentByBedroom {
  studioMedianRent: number | null;
  oneBedroomMedianRent: number | null;
  twoBedroomMedianRent: number | null;
  threeBedroomMedianRent: number | null;
  fourPlusBedroomMedianRent: number | null;

  constructor(data: {
    studioMedianRent: number | null;
    oneBedroomMedianRent: number | null;
    twoBedroomMedianRent: number | null;
    threeBedroomMedianRent: number | null;
    fourPlusBedroomMedianRent: number | null;
  }) {
    this.studioMedianRent = data?.studioMedianRent ?? null;
    this.oneBedroomMedianRent = data?.oneBedroomMedianRent ?? null;
    this.twoBedroomMedianRent = data?.twoBedroomMedianRent ?? null;
    this.threeBedroomMedianRent = data?.threeBedroomMedianRent ?? null;
    this.fourPlusBedroomMedianRent = data?.fourPlusBedroomMedianRent ?? null;
  }
}

export default MedianRentByBedroom;
